// extracted by mini-css-extract-plugin
export var ProcessHero = "Hero-module--ProcessHero--3xl73";
export var ImageWrapper = "Hero-module--ImageWrapper--3jqmt";